import { useEffect, useRef } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import '../Styles/navbar.css'
import {signOut} from 'firebase/auth';
import {auth} from '../firebase-config';
import logos from '../images/LOGOSNF.svg';



function Navbar({setIsAuth, isAuth}) {
    const navRef = useRef();

    const showNavbar = () => {
        console.log("clicked");
        navRef.current.classList.toggle("responsive_nav");
    }

    const signUserOut = () => {
        signOut(auth).then(() => {
          localStorage.clear();
          setIsAuth(false);
          window.location.pathname = '/';
          console.log("looged out");
        })
      }

    return(
        <header className='emosfilemon'>
            <nav ref={navRef}>
                <a href='/'>Strona główna</a>
                <a href='/onas'>O nas</a>
                {!localStorage.getItem("isAuth") ? <a href='login'>Logowanie</a> : <button onClick={signUserOut}>log out</button>}
                <button className='nav-btn nav-close-btn' onClick={showNavbar}>
                    <FaTimes/>
                </button>
            </nav>
            <button className='nav-btn nav-close-btn' onClick={showNavbar}>
                <FaBars/>
            </button>
        </header>
    );
}

export default Navbar;